import React from 'react';
import ReactDOM from 'react-dom';
import createHistory from 'history/createBrowserHistory';
import configureStore from './configureStore';
import configureTheme from './configureTheme';
import App from './App';

const history = createHistory();
const store = configureStore(history);
const theme = configureTheme();

ReactDOM.render(
  <App {...{ store, theme, history }} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.production.js